import styled from 'styled-components';

export const MessageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  flex-direction: column;
  grid-gap: 8px;
  padding: 16px;
  .quilljs {
    width: 100%;
  }
`;

export const MessageInput = styled.textarea`
  border-radius: 5px;
  border: 1px solid #c2c2c2;
  transition: 0.25s ease;
  outline: none;
  padding: 8px;
  max-width: 100%;

  width: calc(50vw - 76px);
  resize: vertical;
  overflow: auto;

  &:hover,
  &:focus {
    border-color: #5c6bc0;
  }
`;

export const MessageBlockContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 16px 24px;
  border: 1px solid ${props => props.theme.main.color};
  border-radius: 4px;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const MessageBlockTitle = styled.div`
  display: flex;
  color: ${props => props.theme.main.color};
  font-weight: 700;
  margin-bottom: 5px;
`;
